<template>
  <v-text-field class="search-criterio"  v-model="searchCriterion"
    solo dark color="#fff" append-icon="search"
    label="Buscar criterio" flat background-color="#42669f"
    hide-details
    @keydown="pressEnter"
    @click:append="searchCriterionByString"
    >
  </v-text-field>
</template>
<script>
export default {
  data () {
    return {
      searchCriterion: ''
    }
  },
  methods: {
    searchCriterionByString () {
      if (this.searchCriterion !== '') {
        this.axios
          .get(`criterion?search=${this.searchCriterion}`)
          .then(response => {
            if (response.data.length !== 0) {
              this.$router.push({
                name: 'searchCriteriosView',
                params: {
                  searchCriterionProp: this.searchCriterion,
                  arrayCriterios: response.data
                }
              })
              this.searchCriterion = ''
            } else {
              this.$store.state.globalInfo = 'No se encontraron resultados para su búsqueda'
            }
          })
          .catch(error => { this.$store.commit('setErrorMsg', error) })
      } else {
        this.$store.state.globalInfo = 'Ingrese un criterio a buscar'
      }
    },
    pressEnter (KeyboardEvent) {
      return KeyboardEvent.key === 'Enter' ? this.searchCriterionByString() : null
    }
  }
}
</script>

<style scoped>
.search-criterio{
  padding: 0.2em 7px 0.2em 18px !important;
  border-bottom: 1px solid;
  border-color: rgba(0, 0, 0, 0.116);
  background-color: #42669f;
}
</style>
